import { ApolloClient } from '@apollo/client';
import axios from 'axios';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Avatar from 'react-avatar';
import { MenuItem, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { withCookies } from 'react-cookie';
import FontAwesome from 'react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { compose } from 'recompose';
import {
  withErrorComponent,
  withLoadingComponent,
  withPage,
  withSelectedLink,
} from '../helper';
import history from '../../core/history';
import { withApolloCLient } from '../../core/ReactHooksHOC';
import withMe from '../App/withMe';
import Link from '../Link';
import s from './Header.module.css';

class TopNav extends Component {
  static contextTypes = {
    setLang: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.changeLanguage = this.changeLanguage.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.logout = this.logout.bind(this);
    this.generateListOfSP = this.generateListOfSP.bind(this);
  }

  partnerAccountChanged(e, link) {
    e.preventDefault();
    history.push(`/${link.partnerAccount.partnerNumber}`);
  }

  generateListOfSP() {
    const links = this.props.me.links || [];
    const partnerAccountName =
      this.props?.selectedLink?.partnerAccount?.name || '';
    const partnerAccountId = this.props?.selectedLink?.partnerAccount?.id || '';

    if (links.length > 1) {
      return (
        <ul
          className={
            'nav navbar-nav pull-left navbar-left ' +
            s.pullRight +
            ' ' +
            s.ulNavbar
          }
        >
          <NavDropdown
            id="dropDown4"
            className={s.navbarProfile}
            eventKey={4}
            title={
              <span>
                <Avatar
                  name={partnerAccountName}
                  className={' ' + s.topnavImg}
                  alt="profile picture"
                  size={30}
                  round
                />
                <span className="hidden-sm">
                  Gestion avec le profil : <strong>{partnerAccountName}</strong>
                </span>
              </span>
            }
            noCaret
          >
            {links.map((link) => {
              return (
                <MenuItem
                  key={`menuitem:${link.partnerAccount.id}`}
                  onClick={(e) => this.partnerAccountChanged(e, link)}
                  active={partnerAccountId === link.partnerAccount.id}
                >
                  <Avatar
                    name={link.partnerAccount.name}
                    className={' ' + s.topnavImg}
                    alt="profile picture"
                    size={30}
                    round
                  />
                  {link.partnerAccount.name}
                </MenuItem>
              );
            })}
          </NavDropdown>
        </ul>
      );
    } else if (links.length === 1) {
      const link = links[0];
      return (
        <div className={`pull-left ${s.padding10} ${s.colorLink}`}>
          <span>
            <Avatar
              name={link.partnerAccount.name}
              className={' ' + s.topnavImg}
              alt="profile picture"
              size={30}
              round
            />
            <span className="hidden-sm">
              Gestion avec le profil : <strong>{partnerAccountName}</strong>
            </span>
          </span>
        </div>
      );
    }

    return null;
  }

  render() {
    const name = `${this.props.data.metaQuery.me.firstName} ${this.props.data.metaQuery.me.lastName}`;
    const list = this.generateListOfSP();

    return (
      <nav
        className={'navbar navbar-fixed-top ' + s.topNavbar}
        role="navigation"
      >
        <div className={'navbar-header text-center ' + s.navbarHeader}>
          <button
            type="button"
            className="navbar-toggle"
            onClick={this.showMenu}
            target="myNavbar"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
          <div>
            <Link to="/" className={`navbar-brand ${s.navbarBrand}`}>
              Portail Partenaire
            </Link>
          </div>
        </div>
        <div
          id="myNavbar"
          className={
            'collapse navbar-collapse ' + s.navbarCollapse + ' ' + s.navbarNav
          }
        >
          {list}
          <ul className={`nav navbar-nav ${s.ulNavbar}`}>
            <Navbar.Text>
              {this.props.currentPage ? this.props.currentPage.pageTitle : ''}
            </Navbar.Text>
            <NavItem
              eventKey={1}
              target="_blank"
              href={
                this.props.currentPage
                  ? `${window.__APP_CONFIG__.DOCUMENTATION_URL}${this.props.currentPage.pageURL}`
                  : ''
              }
            >
              <FontAwesome name="question-circle" />
              &nbsp;
            </NavItem>
          </ul>
          <ul
            className={
              'nav navbar-nav pull-right navbar-left ' +
              s.pullRight +
              ' ' +
              s.ulNavbar
            }
          >
            <NavDropdown
              id="dropDown4"
              className={s.navbarProfile}
              eventKey={4}
              title={
                <span>
                  <Avatar
                    name={name}
                    className={' ' + s.topnavImg}
                    alt="profile picture"
                    size={30}
                    round
                  />
                  <span className="hidden-sm">{name}</span>
                </span>
              }
              noCaret
            >
              <MenuItem
                onClick={(e) => {
                  e.preventDefault();
                  history.push(
                    `/${this.props.selectedLink.partnerAccount.partnerNumber}/profile`,
                  );
                }}
              >
                <FontAwesome name="user" />
                &nbsp;
                <FormattedMessage id="profile" defaultMessage="Profile" />
              </MenuItem>
              <MenuItem onClick={this.logout}>
                <FontAwesome name="sign-out" />
                &nbsp;
                <FormattedMessage id="logout" defaultMessage="Logout" />
              </MenuItem>
            </NavDropdown>
          </ul>
        </div>
      </nav>
    );
  }

  changeLanguage(e) {
    // add code related to language change through app store
    window.localStorage.setItem('language123', e);
    this.context.setLang(e);
  }

  showMenu() {
    $('.dashboard-page').toggleClass('push-right');
  }

  logout(e) {
    const deleteCookie = () => {
      const playSessionCookie = this.props.cookies.get('PLAY_SESSION');
      if (playSessionCookie) {
        const { domain } = playSessionCookie;
        this.props.cookies.remove('PLAY_SESSION', { domain });
      }
      // tries to delete anyway
      else {
        document.cookie = `PLAY_SESSION=; domain=${window.__APP_CONFIG__.KIWI_URL} ; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      }
    };

    const cleanAndRedirect = () => {
      deleteCookie();
      this.props.client.resetStore();
      history.push('/');
    };

    e.preventDefault();
    axios
      .head(`${window.__APP_CONFIG__.KIWI_URL}/logout`, {
        withCredentials: true,
      })
      .then((response) => {
        if (response.status !== 200 && import.meta.env.DEV) {
          console.log(response);
        }

        cleanAndRedirect();
      })
      .catch((error) => {
        if (import.meta.env.DEV) console.error(error);
        cleanAndRedirect();
      });
  }
}

TopNav.propTypes = {
  me: PropTypes.object,
  client: PropTypes.instanceOf(ApolloClient),
  partnerNumber: PropTypes.string,
};

export default compose(
  withMe,
  withCookies,
  withLoadingComponent(),
  withErrorComponent(),
  withApolloCLient,
  withPage,
  withSelectedLink,
)(TopNav);
